/**
 * Takes an Error and returns a string representation formatted in the style of the Chrome devtools
 * JS console.
 */
export function formatError(value: Error): string {
	// Use Error's implementation of `toString` to prevent overriding by subclasses.
	const errorToString = Error.prototype.toString;
	const stack = value.stack || errorToString.call(value);
	return `${value.message}\n${stack}`;
}
